import React, { useState } from 'react';
import { Mail, ExternalLink } from 'lucide-react';
import RequestAccessModal from './RequestAccessModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleContact = () => {
    window.location.href = 'https://alpenglowstudio.com/contact-us';
  };

  const handleRequestAccess = () => {
    setIsModalOpen(true);
  };

  return (
    <footer className="bg-[#0a2e2e] border-t border-[#8b956d]/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://customer-assets.emergentagent.com/job_excalibur-login/artifacts/xx3h8d4i_Excalibur.png"
                alt="Excalibur Logo"
                className="h-12 w-auto"
              />
              <span className="text-2xl font-bold text-[#c5c9b8] font-['Cinzel'] tracking-wider">
                EXCALIBUR
              </span>
            </div>
            <p className="text-[#b5bca0] text-sm leading-relaxed">
              The legendary all-in-one CRM platform built on GoHighLevel. Empowering businesses with cutting-edge automation and limitless growth.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-[#c5c9b8] mb-4">Platform</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://app.alpenglowstudio.net"
                  className="text-[#b5bca0] hover:text-[#8b956d] transition-colors duration-300 flex items-center group"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Login</span>
                  <ExternalLink className="ml-1 w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </a>
              </li>
              <li>
                <button
                  onClick={handleRequestAccess}
                  className="text-[#b5bca0] hover:text-[#8b956d] transition-colors duration-300"
                >
                  Request Access
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold text-[#c5c9b8] mb-4">Get in Touch</h3>
            <button
              onClick={handleContact}
              className="flex items-center space-x-2 text-[#b5bca0] hover:text-[#8b956d] transition-colors duration-300 group"
            >
              <Mail className="w-5 h-5" />
              <span>Contact Us</span>
            </button>
            <p className="text-[#b5bca0] text-sm mt-4 leading-relaxed">
              Powered by Alpenglow Studio
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#8b956d]/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#b5bca0] text-sm">
              © {currentYear} Excalibur CRM. All rights reserved.
            </p>
            <p className="text-[#8b956d] text-sm">
              Built on GoHighLevel Technology
            </p>
          </div>
        </div>
      </div>

      {/* Request Access Modal */}
      <RequestAccessModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </footer>
  );
};

export default Footer;
